import React from 'react';
import TableC from '../../../basicElement/TableC';

function getRender(key) {
    return (text, record) => {
        const { performanceScoreId } = record;
        if (!performanceScoreId) {
            return <strong>{text}</strong>;
        }
        return text;
    }
}

export default function MainPerformance(props) {
    const { loading, data } = props;

    const getColumns = () => ([
    {
        title: '考核项',
        dataIndex: 'performanceScoreName',
        key: 'performanceScoreName',
        width: 100,
        render: getRender('performanceScoreName')
    }, {
        title: '得分',
        dataIndex: 'scoreValue',
        key: 'scoreValue',
        width: 100,
        render: getRender('scoreValue')
    }]);

    const getDataSource = () => {
        return data || [];
    };

    return (
        <div>
            <div style={{ lineHeight: '48px' }}>1.主要业绩分明细</div>
            <TableC
                loading={loading}
                columns={getColumns()}
                data={getDataSource()}
                className="mainPerformance"
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/tables/MainPerformance.js